
const host = window.location.host === "xchge.nysmesonet.org" || window.location.host.split(":")[0] === "localhost";
const domain = host ? 'https://xchge.nysmesonet.org': 'https://chge.nysmesonet.org'; 

const api_url = `${domain}/api/index.php`;


async function getNFDRS(evalDate) {
    try {
        //const csvFile = locateCsvFile(evalDate);

        const csvData = await fetchCsvData(api_url +"/get_nfdrs_nysm/"+`${evalDate.replace(/-/g, '')}`);


        if (csvData) {
            const json_data = csv2json(csvData);
            return json_data;
        } else {
            throw new Error("CSV data is empty or could not be fetched.");
        }
    } catch (error) {
        //console.error(`Error in getNFDRS: ${error.message}`);
        return null;
    }
}


async function getNFDRSbyStn(sdate, edate, sta_nm, model = '3') {
    console.log("Fetching NFDRS data for station ID:", sta_nm);

    const startDate = new Date(sdate);
    const endDate = new Date(edate);
    const dateRange = [];

    for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
        dateRange.push(new Date(d));
    }

    const results = [];
    for (const date of dateRange) {
        const formattedDate = date.toISOString().split('T')[0];
        const jsonData = await getNFDRS(formattedDate);
        if (jsonData) {
            const filteredData = jsonData.filter(entry => entry['StationID'] === sta_nm);
            results.push(...filteredData);
        }
    }
    return results;
}

async function getNfdrsClimo(sta_nm, param) {
    try {
        //const csvFile = locateCsvFile(evalDate);
        const csvData = await fetchCsvData(api_url +"/get_historic/"+ param +"/"+ sta_nm);

        if (csvData) {
            const json_data = csv2json(csvData);
            return json_data;
        } else {
            throw new Error("CSV data is empty or could not be fetched.");
        }
    } catch (error) {
        console.error(`Error in getNFDRS: ${error.message}`);
        return null;
    }
}



async function fetchCsvData(csvFile) {
    try {
        const response = await fetch(csvFile);
        if (!response.ok) {
            throw new Error(`Network response was not ok, status: ${response.status}`);
        }
        const data = await response.text();
        return data;
    } catch (error) {
        //console.error(`Error fetching CSV data: ${error.message}`);
        return null;
    }
}

function csv2json(csvData, model=false) {
    try {
        const lines = csvData.split('\n');
        const headers = lines[0].split(',');

        const jsonData = [];
        for (let i = 1; i < lines.length; i++) {
            const currentLine = lines[i].split(',');
            const entry = {};

            for (let j = 0; j < headers.length; j++) {
                entry[headers[j]] = currentLine[j];
            }

            //filter by model
            if(model){
                if (entry['mp'] === model) {
                    jsonData.push(entry);
                }
            }else{
                jsonData.push(entry);
            }

        }

        return jsonData;
    } catch (error) {
        console.error(`Error parsing CSV data to JSON: ${error.message}`);
        return [];
    }
}

export { getNFDRS, getNFDRSbyStn, getNfdrsClimo };